import { ApplicationRef, Injectable, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import * as $ from 'jquery';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from './api.service';
import { GlobalService } from './global.service';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';

declare var jPlayerPlaylist: any;

@Injectable({
    providedIn: 'root'
})

export class PlayerService {

    myPlaylist: any;
    playerReady: Boolean = false;
    playingItemNum = 0;
    currentSlug = '';
    playing: Boolean = false;
    title = '';
    clapsCount = 0;
    totalClapsCount = 0;

    currentItemTitle = '';
    currentItemSlug = '';
    currentItemArtist = '';
    currentItemArtistSlug = '';
    currentItemProfilePic = '';
    currentItemlyrics = '';

    currentTime = 0;
    totalDuration = 100;

    activityId = 0;

    loading: Boolean = false;
    slugSubject = new Subject();
    slugSubjectLyrics = new Subject();
    countClaps = new Subject();

    /**************** Audio Player Selector Start ******************/
    cssSelector = {
        jPlayer: '#jplayer_N',
        cssSelectorAncestor: '#jp_container_N'
    };
    /**************** Audio Player Selector End ******************/


    /**************** Audio Player Playlist Start ******************/
    playlist = [];
    /**************** Audio Player Playlist End ******************/


    /**************** Audio Player Options Start ******************/
    options: any;
    /**************** Audio Player Options End ******************/

    companion = [];
    companionActive: any;
    companionLoaded = false;
    companionTimeStatus = false;


    constructor(
        private toastrService: ToastrService,
        private api: ApiService,
        private global: GlobalService,
        private titleService: Title,
        private ref: ApplicationRef
    ) {
        if (this.global.isBrowser) {
            const angularthis = this;
            // this.titleService.setTitle('hello bufallo');
            const baseTitle = this.titleService.getTitle();
            if (angularthis.global.isBrowser) {
                if ('mediaSession' in navigator) {
                    (navigator as any).mediaSession.setActionHandler('previoustrack', angularthis.playPrevious.bind(angularthis));
                    (navigator as any).mediaSession.setActionHandler('nexttrack', angularthis.playNext.bind(angularthis));
                }
            }

            /**************** Audio Player Options Start ******************/
            this.options = {
                playlistOptions: {
                    enableRemoveControls: true,
                    autoPlay: false
                },
                swfPath: 'js/jPlayer',
                supplied: 'webmv, ogv, m4v, oga, mp3',
                smoothPlayBar: true,
                keyEnabled: false,
                audioFullScreen: false,
                remainingDuration: true,
                toggleDuration: true,

                ready: function () {
                    // console.log('MP3 Player Initialized');
                    angularthis.playerReady = true;

                    angularthis.advertisement();
                },

                play: function (e) {
                    if (angularthis.global.isBrowser) {
                        //console.log(angularthis.playlist)
                        angularthis.currentSlug = angularthis.playlist[angularthis.myPlaylist.current].slug;

                        angularthis.slugSubject.next(angularthis.currentSlug)
                        angularthis.slugSubjectLyrics.next(angularthis.currentItemlyrics)

                        angularthis.title = angularthis.playlist[angularthis.myPlaylist.current].title;
                        angularthis.totalClapsCount = angularthis.playlist[angularthis.myPlaylist.current].totalClapsCount;
                        angularthis.clapsCount = angularthis.playlist[angularthis.myPlaylist.current].clapsCount;

                        angularthis.playlist[angularthis.myPlaylist.current].title = angularthis.currentItemTitle;
                        angularthis.playlist[angularthis.myPlaylist.current].slug = angularthis.currentItemSlug;
                        angularthis.playlist[angularthis.myPlaylist.current].artist = angularthis.currentItemArtist;
                        angularthis.playlist[angularthis.myPlaylist.current].artistSlug = angularthis.currentItemArtistSlug;
                        angularthis.playlist[angularthis.myPlaylist.current].image = angularthis.currentItemProfilePic;
                        angularthis.playlist[angularthis.myPlaylist.current].profilePic = angularthis.currentItemProfilePic;
                        angularthis.playlist[angularthis.myPlaylist.current].lyrics = angularthis.currentItemlyrics;

                        angularthis.getPlayingSongDetails(angularthis.currentSlug);
                        ref.tick();
                        angularthis.loadCompanion();

                        // console.log('Play started...');
                        angularthis.playing = true;

                        const duration = e.jPlayer.status.currentTime;
                        angularthis.currentSlug = angularthis.playlist[angularthis.myPlaylist.current].slug;
                        /* angularthis.titleService.setTitle( angularthis.playlist[angularthis.myPlaylist.current].title
                            + ' by ' + angularthis.playlist[angularthis.myPlaylist.current].artist
                            + ' | ' + baseTitle); */

                        if (duration === 0) {
                            angularthis.global.trackEvent('Total-track-play', angularthis.currentSlug);

                            // angularthis.getPlayerSong(angularthis.currentSlug);

                            // console.log('Player totalClapsCount: ', angularthis.totalClapsCount);
                            if ('mediaSession' in navigator) {
                                // @ts-ignore
                                navigator.mediaSession.metadata = new MediaMetadata({
                                    title: angularthis.playlist[angularthis.myPlaylist.current].title,
                                    artist: angularthis.playlist[angularthis.myPlaylist.current].artist,
                                    artwork: [
                                        {
                                            src: angularthis.playlist[angularthis.myPlaylist.current].image,
                                            type: 'image/png',
                                        }]
                                });
                                /* ts-ignore */
                            }
                            angularthis.api.playSong(angularthis.playlist[angularthis.myPlaylist.current].slug, 'song').subscribe(res => {
                                // console.log('Play update success: ', res);
                                angularthis.activityId = res.id;
                            },
                                (err: HttpErrorResponse) => {
                                    if (err.error instanceof Error) {
                                        // console.log('Play update error: Client-side error occured!');
                                    } else {
                                        // console.log('Play update error: Server-side error occured!', err);
                                    }
                                });

                            $('.playsCount_' + angularthis.currentSlug + ':not(.albumTotalCount)').html((parseInt($('.playsCount_' + angularthis.currentSlug + ':not(.albumTotalCount)').html()) + 1).toString());
                            $('.playsCount_' + angularthis.currentSlug + '.albumTotalCount').html((parseInt($('.playsCount_' + angularthis.currentSlug + '.albumTotalCount').html()) + 1).toString());
                        }
                    }
                },

                solution: 'html,flash',
                errorAlerts: false,
                warningAlerts: false,

                pause: function (e) {
                    if (angularthis.global.isBrowser) {
                        // console.log('Paused');
                        // console.log(e.jPlayer.status);
                        // angularthis.titleService.setTitle(baseTitle);
                        angularthis.playing = false;

                        // $('.musicbar').removeClass('animate');
                        // $('.play-me.playing').removeClass('playing').addClass('pause').parents('.songWidget').removeClass('playing').addClass('pause');

                        const duration = e.jPlayer.status.currentTime;
                        angularthis.currentSlug = angularthis.playlist[angularthis.myPlaylist.current].slug;
                        /*angularthis.api.playSong(angularthis.playlist[angularthis.myPlaylist.current].slug, 'song', duration, angularthis.activityId).subscribe(res => {
                            // console.log('Play update success: ', res);
                        },
                            (err: HttpErrorResponse) => {
                                if (err.error instanceof Error) {
                                    // console.log('Play update error: Client-side error occured!');
                                } else {
                                    // console.log('Play update error: Server-side error occured!', err);
                                }
                            });
                            */
                    }
                },

                loadstart: function () {
                },
                loadeddata: function (e) {
                    if (angularthis.global.isBrowser) {
                        // console.log('song loading over');
                        // $('#playerLoader').addClass('hidden').removeClass('flex');
                        angularthis.loading = false;
                        angularthis.totalDuration = e.jPlayer.status.duration;
                        // console.log('Total Duration: ' + angularthis.totalDuration);
                    }
                },

                next: function () {
                    // console.log('next');
                },

                timeupdate: function (e) {
                    if (angularthis.global.isBrowser) {
                        // jQuery('#finish_time').html(jQuery('.jp-duration').html());
                        angularthis.currentTime = e.jPlayer.status.currentTime;
                        // angularthis.totalDuration = e.jPlayer.status.duration;
                        // // console.log('Current Time: ' + angularthis.currentTime);
                        // // console.log('Total Duration: ' + angularthis.totalDuration);
                        angularthis.loadCompanion();
                    }
                },

                progress: function (e) {
                    // displayLoadingPercent(e.jPlayer.status.seekPercent);
                    // // console.log('progress');
                    // // console.log(e);
                },

                seeking: function (e) {
                },

                seeked: function (e) {
                    // seekWaveForm();
                },

                ended: function () {
                    // clearwaveform();
                }
            };
            /**************** Audio Player Options End ******************/

            if (localStorage.getItem('userPlaylist27Apr')) {
                this.playlist = JSON.parse(localStorage.getItem('userPlaylist27Apr'));
            }

            if (this.playlist.length == 0) {
                // Komal Chandra (30 Aug 2020) - hitting queue after 15sec to improve the google page insights score
                setTimeout(() => {
                    if (this.playlist.length == 0) {
                        this.api.getQueue().subscribe(res => {
                            if (res.success) {
                                res.results.forEach(track => {
                                    this.playlist.push({
                                        'title': track.title,
                                        'artist': track.name,
                                        'artistSlug': track.artist_slug,
                                        'mp3': track.song,
                                        'm4a': track.song,
                                        'image': track.image,
                                        'slug': track.song_slug,
                                        'clapsCount': track.user_claps,
                                        'lyrics': track.lyrics,
                                        'totalClapsCount': track.song_claps
                                    });
                                });

                                if (this.playlist.length > 0) {
                                    this.currentItemTitle = this.playlist[0].title;
                                    this.currentItemSlug = this.playlist[0].slug;
                                    this.currentItemArtist = this.playlist[0].artist;
                                    this.currentItemArtistSlug = this.playlist[0].artistSlug;
                                    this.currentItemProfilePic = this.playlist[0].image;
                                    this.currentItemlyrics = this.playlist[0].lyrics ? this.playlist[0].lyrics.replace(/(style=")(.*)(")/gi, '') : '';
                                }

                                // if ( this.playlist.length > 0 ) {
                                //     this.currentSlug = this.playlist[0].slug;
                                //     this.title = this.playlist[0].title;
                                //     this.clapsCount = this.playlist[0].clapsCount;
                                //     this.totalClapsCount = this.playlist[0].totalClapsCount;
                                // }

                                // console.log(this.playlist);

                                this.initialisePlayer();

                                if (this.myPlaylist != undefined && this.myPlaylist != null) {
                                    this.myPlaylist.setPlaylist(this.playlist);
                                }
                            } else {
                                this.initialisePlayer();
                            }
                        },
                            (err: HttpErrorResponse) => {
                                this.initialisePlayer();
                            });
                    }
                }, 1000);
            } else {
                this.initialisePlayer();
            }

            if (this.playlist.length > 0) {
                this.currentItemTitle = this.playlist[0].title;
                this.currentItemSlug = this.playlist[0].slug;
                this.currentItemArtist = this.playlist[0].artist;
                this.currentItemArtistSlug = this.playlist[0].artistSlug;
                this.currentItemProfilePic = this.playlist[0].image;
                this.currentItemlyrics = this.playlist[0].lyrics ? this.playlist[0].lyrics.replace(/(style=")(.*)(")/gi, '') : '';
            }
        }
    }

    /**************** Audio Player Initialization (if not already initialized) Start ******************/
    initialisePlayer() {
        if (!this.playerReady && this.global.isBrowser) {
            // console.log('Initialising MP3 player...');

            this.myPlaylist = new jPlayerPlaylist(
                this.cssSelector,
                this.playlist,
                this.options
            );

            // console.log('Initialised');
        }
    }
    /**************** Audio Player Initialization End ******************/


    /**************** Method to Play Audio Start ******************/
    playAudio(playlist, event, itemNum = 0, from = '') {
        this.global.showPlayer = true;

        let angularthis = this;
        if (this.global.isBrowser) {
            this.initialisePlayer();
            let obj = $(event.target);
            if (!obj.is('.play-me')) {
                obj = obj.closest('.play-me');
            }

            if (from === 'queue') {
                if (obj.hasClass('playing')) {
                    angularthis.myPlaylist.pause();
                    // obj.removeClass('playing').addClass('pause').parents('.songWidget').removeClass('playing').addClass('pause');
                } else if (obj.hasClass('pause')) {
                    angularthis.myPlaylist.play();
                    // obj.removeClass('pause').addClass('playing').parents('.songWidget').removeClass('pause').addClass('playing');
                } else {
                    // console.log('song loading started');
                    // $('#playerLoader').addClass('flex').removeClass('hidden');
                    angularthis.loading = true;
                    // console.log('Item num: ' + itemNum);
                    angularthis.playingItemNum = itemNum;
                    // angularthis.myPlaylist.play(itemNum);
                    angularthis.currentSlug = angularthis.playlist[itemNum].slug;
                    angularthis.getPlayerSong(angularthis.currentSlug);
                }
            } else {
                // console.log('Song play button clicked');
                $('.songWidget .lyrics').removeClass('active');

                const angularthis = this;
                if (obj.hasClass('playing')) {
                    // console.log('pausing outside');
                    angularthis.myPlaylist.pause();
                    // obj.removeClass('playing').addClass('pause').parents('.songWidget').removeClass('playing').addClass('pause');
                } else if (obj.hasClass('pause')) {
                 //console.log('pausing outside');
                    angularthis.myPlaylist.play();
                    // obj.removeClass('pause').addClass('playing').parents('.songWidget').removeClass('pause').addClass('playing');
                } else {
                    if (playlist.length === 0) {
                        // console.log('Received empty playlist!');
                    } else {
                        angularthis.loading = true;

                        // console.log('Added to Playlist: ', playlist);

                        if (angularthis.playlist.length > 20) {
                            angularthis.playlist.splice(0, (angularthis.playlist.length - 20));
                        }

                        let currentItem = 0;
                        if (angularthis.playlist.length > 0) {
                            currentItem = angularthis.playlist.length + itemNum;
                        } else {
                            currentItem = 0 + itemNum;
                        }
                        angularthis.playingItemNum = currentItem;


                        playlist.forEach(element => {
                            angularthis.playlist.push(element);
                        });

                        // console.log('Playlist: ' + this.playlist);
                        localStorage.setItem('userPlaylist27Apr', JSON.stringify(angularthis.playlist));

                        if (angularthis.myPlaylist != undefined && angularthis.myPlaylist != null) {
                            angularthis.myPlaylist.setPlaylist(angularthis.playlist);
                        }


                        // angularthis.myPlaylist.play(currentItem);
                        angularthis.currentSlug = angularthis.playlist[angularthis.playingItemNum].slug;
                        angularthis.getPlayerSong(angularthis.currentSlug);

                        angularthis.currentItemTitle = angularthis.playlist[angularthis.playingItemNum].title;
                        angularthis.currentItemSlug = angularthis.playlist[angularthis.playingItemNum].slug;
                        angularthis.currentItemArtist = angularthis.playlist[angularthis.playingItemNum].artist;
                        angularthis.currentItemArtistSlug = angularthis.playlist[angularthis.playingItemNum].artistSlug;
                        angularthis.currentItemProfilePic = angularthis.playlist[angularthis.playingItemNum].image;
                        angularthis.currentItemlyrics = angularthis.playlist[angularthis.playingItemNum].lyrics ? angularthis.playlist[angularthis.playingItemNum].lyrics.replace(/(style=")(.*)(")/gi, '') : '';
                    }
                }
            }
        }
    }
    /**************** Method to Play Audio End ******************/


    /**************** Method to remove tracks Start ******************/
    removeTrack(index) {
        if (this.global.isBrowser) {
            this.playlist.splice(index, 1);
            // this.myPlaylist.remove(index);
            this.myPlaylist.original.splice(index, 1);
            this.myPlaylist.playlist.splice(index, 1);

            if (index < this.myPlaylist.current) {
                this.myPlaylist.current--;
            }

            localStorage.setItem('userPlaylist27Apr', JSON.stringify(this.playlist));
            // console.log(this.myPlaylist);
            // console.log(this.playlist);

            if (this.playlist.length == 0) {
                this.currentSlug = '';
                $('.queue').removeClass('active');
            } else {
                this.currentSlug = this.playlist[this.myPlaylist.current].slug;
            }
        }
    }

    removeAll() {
        if (this.global.isBrowser) {
            let pseudoPlaylist = [this.playlist[this.myPlaylist.current]];
            this.playlist = pseudoPlaylist;
            this.myPlaylist.original = pseudoPlaylist;
            this.myPlaylist.playlist = pseudoPlaylist;
            this.myPlaylist.current = 0;
            this.currentSlug = this.playlist[this.myPlaylist.current].slug;
            localStorage.setItem('userPlaylist27Apr', JSON.stringify(this.playlist));
            /*
            let pseudoPlaylist = this.playlist;

            let i = 0;
            let j = 0;
            pseudoPlaylist.forEach(item => {
                console.log(i, j, item.slug, pseudoPlaylist[this.myPlaylist.current].slug );
                if ( item.slug != pseudoPlaylist[this.myPlaylist.current].slug ) {
                    this.removeTrack(j);
                    if ( j < this.myPlaylist.current ) {
                        j--;
                    }
                }

                i++;
                j++;
            });*/

            $('.queue').removeClass('active');
        }
    }
    /**************** Method to remove Tracks Start ******************/


    /**************** Method to show/hide Lyrics Start ******************/
    toggleLyrics(event) {
        if (this.global.isBrowser) {
            let obj = $(event.target);
            if (!obj.is('.lyrics-toggle-btn')) {
                obj = obj.closest('.lyrics-toggle-btn');
            }

            if ($(obj).parents('.songWidget').find('.lyrics').hasClass('active')) {
                $('.songWidget .lyrics').removeClass('active');
            } else {
                $('.songWidget .lyrics').removeClass('active');
                $(obj).parents('.songWidget').find('.lyrics').addClass('active');
            }
        }
    }
    /**************** Method to show/hide Lyrics End ******************/


    /**************** Method to AddToQueue Start ******************/
    addToQueue(tracks) {
        if (this.global.isBrowser) {
            // console.log('Add to Queue');
            // console.log(tracks);
            this.toastrService.success('Added to Queue');

            /*
            if ( this.playlist.length > 10 ) {
                this.playlist.splice( 0, (this.playlist.length - 10) );
            }*/

            // console.log(tracks);
            tracks.forEach(element => {
                this.playlist.push(element);

                // this.myPlaylist.add(element);
                // this.myPlaylist.original.push(element);
                // this.myPlaylist.playlist.push(element);
            });
            console.log(tracks);
            localStorage.setItem('userPlaylist27Apr', JSON.stringify(this.playlist));
        }
    }
    /**************** Method to AddToQueue Lyrics End ******************/

    playPrevious() {
        if (this.global.isBrowser) {
            const angularthis = this;

            if (angularthis.myPlaylist.current == 0) {
                if (angularthis.currentTime < 3) {
                    angularthis.myPlaylist.play(angularthis.playlist.length - 1);
                } else {
                    angularthis.myPlaylist.play(angularthis.myPlaylist.current, 0);
                }
            } else {
                if (angularthis.currentTime < 3) {
                    angularthis.myPlaylist.previous();
                } else {
                    angularthis.myPlaylist.play(angularthis.myPlaylist.current, 0);
                }
            }
        }
    }
    playNext() {
        if (this.global.isBrowser) {
            if (this.myPlaylist.current == (this.playlist.length - 1)) {
                this.myPlaylist.play(0);
            } else {
                this.myPlaylist.next();
            }
        }
    }

    roundOff(num) {
        return Math.round(num);
    }

    toggleLoop() {
        if (this.global.isBrowser) {
            const loopValue = this.myPlaylist.option('loopOnPrevious'); // Get option
            this.myPlaylist.option('loopOnPrevious', !loopValue); // Set option
        }
    }


    videoPlaysCount(slug) {
        if (this.global.isBrowser) {
            this.global.trackEvent('total-video-play', slug);

            this.api.playSong(slug, 'video').subscribe(res => {
                // console.log('Play update success: ', res);
                $('.playsCount_' + slug).html((parseInt($('.playsCount_' + slug).html()) + 1).toString());
            },
                (err: HttpErrorResponse) => {
                    if (err.error instanceof Error) {
                        // console.log('Play update error: Client-side error occured!');
                    } else {
                        // console.log('Play update error: Server-side error occured!', err);
                    }
                });
        }
    }


    getPlayerSong(slug) {
        if (this.global.isBrowser) {
            this.loading = true;

            this.api.getPlayerSong(slug).subscribe(res => {
                // console.log('Player Song: ', res);
                if (res.result) {
                    this.currentItemTitle = res.result.title;
                    this.currentItemSlug = res.result.slug_usersong;
                    this.currentItemArtist = res.result.full_name;
                    this.currentItemArtistSlug = res.result.slug_username;
                    this.currentItemlyrics = res.result.lyrics ? res.result.lyrics.replace(/(style=")(.*)(")/gi, '') : '';

                    if (res.result.album_id > 0) {
                        this.currentItemProfilePic = res.result.album.cover_pic;
                    } else {
                        this.currentItemProfilePic = res.result.image;
                    }
                }

                let angularthis = this;
                // let playPromise = angularthis.myPlaylist.play(angularthis.playingItemNum);
                // if (playPromise !== undefined) {
                setTimeout(function () {
                    // console.log('trying play');
                    try {
                        angularthis.myPlaylist.play(angularthis.playingItemNum);
                    } catch (err) {
                        // console.log(err);
                        return; // Cancel execution and wait for the delayed command.
                    }

                    angularthis.loading = false;
                }, 800);
                // }
            },
                (err: HttpErrorResponse) => {
                    if (err.error instanceof Error) {
                        // console.log('Play update error: Client-side error occured!');
                    } else {
                        // console.log('Play update error: Server-side error occured!', err);
                    }

                    let angularthis = this;
                    // let playPromise = angularthis.myPlaylist.play(angularthis.playingItemNum);
                    // if (playPromise !== undefined) {
                    setTimeout(function () {
                        // console.log('trying play');
                        try {
                            angularthis.myPlaylist.play(angularthis.playingItemNum);
                        } catch (err) {
                            // console.log(err);
                            return; // Cancel execution and wait for the delayed command.
                        }

                        angularthis.loading = false;
                    }, 1000);
                    // }
                });
        }
    }
    getPlayingSongDetails(slug) {
        if (this.global.isBrowser) {
            this.loading = true;

            this.api.getPlayerSong(slug).subscribe(res => {
                this.loading = false;
                if (res.result) {
                    this.currentItemTitle = res.result.title;
                    this.currentItemSlug = res.result.slug_usersong;
                    this.currentItemArtist = res.result.full_name;
                    this.currentItemArtistSlug = res.result.slug_username;
                    this.currentItemlyrics = res.result.lyrics ? res.result.lyrics.replace(/(style=")(.*)(")/gi, '') : '';

                    if (res.result.album_id > 0) {
                        this.currentItemProfilePic = res.result.album.cover_pic;
                    } else {
                        this.currentItemProfilePic = res.result.image;
                    }

                    this.playlist[this.myPlaylist.current].title = this.currentItemTitle;
                    this.playlist[this.myPlaylist.current].slug = this.currentItemSlug;
                    this.playlist[this.myPlaylist.current].artist = this.currentItemArtist;
                    this.playlist[this.myPlaylist.current].artistSlug = this.currentItemArtistSlug;
                    this.playlist[this.myPlaylist.current].image = this.currentItemProfilePic;
                    this.playlist[this.myPlaylist.current].profilePic = this.currentItemProfilePic;
                    this.playlist[this.myPlaylist.current].lyrics = this.currentItemlyrics;
                }
            },
                (err: HttpErrorResponse) => {
                    this.loading = false;
                });
        }
    }

    advertisement() {
        this.api.advertisement('companion').subscribe(res => {
            // console.log(res);

            if (res.success) {
                this.companion = res.media;
            }
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    loadCompanion() {
        this.companionLoaded = false;
        this.companionTimeStatus = false;

        this.companion.forEach(item => {
            if ((!this.companionLoaded || !this.companionTimeStatus) && (item.track == null || item.track.includes(this.currentSlug))) {
                this.companionActive = item;
                this.companionLoaded = true;

                if (!this.companionTimeStatus) {
                    let startTime = this.companionActive.start_time;
                    let endTime = this.companionActive.end_time;

                    if (this.currentTime > startTime && this.currentTime < endTime) {
                        this.companionTimeStatus = true;
                    } else {
                        this.companionTimeStatus = false;
                    }
                }
            }
        });
    }
}
